import { getEnv } from "fond/env";

import AnalyticsLogger, { AnalyticsLogLevel } from "./AnalyticsLogger";
import { analyticsEventsSchema } from "./events";
import { MixpanelClient } from "./MixpanelClient";

const logger = new AnalyticsLogger(getEnv("REACT_APP_ANALYTICS_LOGGING") as AnalyticsLogLevel | undefined);
/**
 * Analytics client instance for Mixpanel.
 *
 * This is the main entry point for sending analytics events.
 *
 */
const analytics = new MixpanelClient(analyticsEventsSchema, logger, getEnv("REACT_APP_MIXPANEL_TOKEN") ?? "no_mixpanel_token");

export default analytics;
